import * as yup from 'yup';

export const CreateSchoolScheduleFormValidation = yup.object().shape({
    idClassroom: yup.string().required('Sala é obrigatória'),
    dayOfTheWeek: yup.string().required('Dia da semana é obrigatória'),
    idClass: yup.string().required('Turma é obrigatória'),
    startTime: yup.string().required('Hora de início é obrigatória'),
    endTime: yup.string()
        .required('Hora de fim é obrigatória')
        .test('is-greater', 'Hora de fim deve ser maior que a hora de início, e deve ser maior ou igual a 45min.', function (endTime) {
            const { startTime } = this.parent;
            if (!startTime || !endTime) return true; 
            const start = new Date(`1970-01-01T${startTime}:00`);
            const end = new Date(`1970-01-01T${endTime}:00`);
            if (end <= start) {
                return false; 
            }
            const differenceInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
            return differenceInMinutes >= 45;
        }),
    idTeacher: yup.string().required('Docente é obrigatório'),
    idSubject: yup.string().required('Disciplina é obrigatória'),
});
